import * as React from "react";

import { workspaceRouter } from "@editor/trpc/workspace";

import Selectable from "../common/designSystem/Selectable";

export function WorkspaceSelectable({
  value,
  onChange,
}: {
  value: string | null;
  onChange: (value: string) => void;
}) {
  const { data } = workspaceRouter.getUserWorkspacesList.useQuery();
  const workspaces = data?.workspaces ?? [];
  return (
    <Selectable
      size="base"
      areOptionsSearchable={workspaces.length > 5}
      placeholder="Choose Workspace"
      options={workspaces.map((workspace) => ({
        label: workspace.name,
        value: workspace.id,
      }))}
      value={value}
      onSelect={onChange}
    />
  );
}
